const controller = "ai/location-resolution";

export default {
  search: `${controller}/search`,
  reverseGeocode: (resolutionId: string) => `${controller}/${resolutionId}/reverse-geocode`,
  confirm: (resolutionId: string) => `${controller}/${resolutionId}/confirm`,
};
